import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { wfApi } from '../../api/workflow.js';
import { useNotifications } from '../../contexts/NotificationContext.jsx';

export default function MyApprovals() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { refresh: refreshNotifications } = useNotifications();

  function refresh() {
    setLoading(true);
    wfApi.myApprovals().then((d) => setItems(d?.items || [])).finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function decide(id, action) {
    setError(null);
    const comments = window.prompt(`Comments for ${action}? (optional)`) || '';
    try {
      if (action === 'approve') await wfApi.approve(id, comments);
      else await wfApi.reject(id, comments);
      refresh();
      refreshNotifications();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  return (
    <section>
      <header className="page-header">
        <h1>My Approvals</h1>
        <span className="muted">{items.length} pending</span>
      </header>

      {error && <div className="alert error">{error}</div>}
      {loading && <div className="muted">Loading…</div>}

      {!loading && items.length === 0 && (
        <div className="card center muted">All caught up — no pending approvals.</div>
      )}

      <div className="approvals">
        {items.map((it) => (
          <div key={it.instance_step_id} className="card approval-card">
            <header className="approval-head">
              <div>
                <strong>{it.step_name}</strong>
                <span className="muted small"> · {humanResource(it.resource_type)}</span>
              </div>
              <Due dueAt={it.due_at} />
            </header>
            <ContextSummary type={it.resource_type} ctx={typeof it.context === 'string' ? JSON.parse(it.context) : it.context} />
            <p className="muted small">From {it.initiator_name || it.initiator_email || '—'} · workflow: {it.definition_name}</p>
            <div className="actions">
              <Link to={`/workflows/instances/${it.instance_id}`} className="btn ghost small">View context</Link>
              <button className="btn ghost small danger-btn" onClick={() => decide(it.instance_step_id, 'reject')}>Reject</button>
              <button className="btn primary small" onClick={() => decide(it.instance_step_id, 'approve')}>Approve</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function humanResource(s) { return String(s).replace(/_/g, ' '); }

function Due({ dueAt }) {
  if (!dueAt) return null;
  const due = new Date(dueAt);
  const overdue = due < new Date();
  return (
    <span className={`chip ${overdue ? 'status-rejected' : 'status-pending'}`}>
      {overdue ? 'Overdue · ' : 'Due '}{due.toLocaleString()}
    </span>
  );
}

function ContextSummary({ type, ctx }) {
  if (!ctx) return null;
  if (type === 'leave_request') {
    return (
      <p className="muted small">
        {ctx.days} day(s) · {ctx.startDate} → {ctx.endDate}
      </p>
    );
  }
  // Generic — show first few keys.
  const keys = Object.keys(ctx).slice(0, 4);
  if (!keys.length) return null;
  return (
    <p className="muted small">
      {keys.map((k) => `${k}: ${formatVal(ctx[k])}`).join(' · ')}
    </p>
  );
}

function formatVal(v) {
  if (v == null) return '—';
  if (typeof v === 'object') return JSON.stringify(v).slice(0, 40);
  return String(v);
}
